import styled from '@emotion/styled';
import {Img as ImgUI, colors, Text} from 'ui';

export const Circle = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  width: 72,
  maxWidth: 72,
  marginRight: 7,
  marginLeft: 7,
  paddingTop: 6,
});

export const Mask = styled('div')(({selected}) => ({
  width: selected ? 82 : 72,
  minWidth: selected ? 82 : 72,
  height: selected ? 82 : 72,
  borderRadius: '50%',
  marginTop: selected ? -5 : null,
  marginBottom: selected ? 4 : 9,
  padding: selected ? 4 : null,
  border: selected ? `1px solid ${colors.caramel}` : null,
}));

export const Img = styled(ImgUI)({
  width: 72,
  minWidth: 72,
  height: 72,
  borderRadius: '50%',
  marginBottom: 8,
});

export const Label = styled(Text)(({selected}) => ({
  color: selected ? colors.caramel : colors.darkBrown,
  textDecoration: selected ? 'underline' : null,
  textAlign: 'center',
  fontWeight: 500,
}));
